import type { ValueRange } from '~~/types/ValueRange';
import type { CtSearchProductsFacet } from '~~/types/productListing/CtSearchProductsResult';

export const getCtPriceFacetRange = (facet: CtSearchProductsFacet | undefined): ValueRange | null => {

  if (!facet || typeof facet.min !== 'number' || typeof facet.max !== 'number') {

    return null;

  }

  // Price facet is on centAmount — convert back to major currency units for display.
  return {
    min: Math.floor(facet.min / 100),
    max: Math.ceil(facet.max / 100),
  };

};
